// Único punto de cálculo del valor con descuento de un servicio. El precio
// final no es un dato que alguien escriba: siempre se deriva del original y
// del porcentaje de descuento, para que los tres números no puedan quedar
// sin relación entre sí -- un descuento que no corresponde al precio final
// que lo acompaña termina en el documento que el cliente firma. La
// comparten la creación de una propuesta y el ajuste de sus servicios: un
// cambio de redondeo acá afecta a las dos.
export const calcValorConDescuento = (valorOriginal, descuento) => {
  const v = Number(valorOriginal) || 0;
  const d = Number(descuento) || 0;
  if (d <= 0) return v;
  return Number((v * (1 - d / 100)).toFixed(2));
};
